import React from 'react';
import Breadcrumb from '../components/utils/Breadcrumb';
import NewPositionForm from '../components/position/NewPositionForm';

const NewPosition = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-10 pt-16">
      {/* Breadcrumb */}
      <Breadcrumb items={[
        { label: 'Dashboard', href: '/app', icon: 'bi-house' },
        { label: 'Postes', href: '/offers', icon: 'bi-briefcase' },
        { label: 'Nouveau Poste', href: null, icon: 'bi-plus-circle', isActive: true }
      ]} />

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Nouveau Poste</h1>
          <p className="text-gray-600">Créez une nouvelle offre d'emploi pour l'une de vos entreprises partenaires</p>
        </div>
      </div>

      {/* Form Container */}
      <div className="max-w-4xl mx-auto">
        <NewPositionForm />
      </div>
    </div>
  );
};

export default NewPosition;